<template>
  <div class="exchangeBaseInfo">
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        换货合同
      </div>
      <div class="rj-page-card__content">
        <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
          <div class="rj-row">
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位（甲方）：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyUnit }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  原合同编码：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.roldContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  场景分类：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rScenarioCategory }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  电子商务合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rnewContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位（乙方）：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rorderUnitName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rnewContractCustomerNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  项目名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rprojectName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  最终客户名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rfinalCustomerName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rcreatedTime }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  外销姓名：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rsalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  售前姓名：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rpreSalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rintegratorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  末级集成商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.finalIntegratorsName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  计量集成商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.metrologyIntegratorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  A类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rserviceAName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  B类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rserviceBName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  C类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rserviceCName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  现销或赊销：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rsalesSettlementModes === 1?' 现销':'赊销' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  账期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.raccountPeriod }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  发货方式：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rdeliveryMethod===1? '齐套发货':'分批发货' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  使用返利金额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.ruseRebateAmount }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  计量计点：
                </div>
                <div v-if="info.rmeteringPoint === 1" class="rj-baseinfo__item">
                  计量计点
                </div>
                <div v-if="info.rmeteringPoint === 2" class="rj-baseinfo__item">
                  计量不计点
                </div>
                <div v-if="info.rmeteringPoint === 3" class="rj-baseinfo__item">
                  不计量不计点
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  齐套打款通知邮箱：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.businessEmail }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  运输方式：
                </div>
                <div class="rj-baseinfo__item" />
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  承运商：
                </div>
                <div class="rj-baseinfo__item" />
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  运费金额：
                </div>
                <div class="rj-baseinfo__item" />
              </div>
            </div>

            <div class="rj-col-1">
              <el-form-item prop="additionalTerms" label="补充条款:">
                <el-input v-model.trim="info.rsupplementalTerm" type="textarea" disabled :rows="3" placeholder="请输入补充条款内容" />
              </el-form-item>
            </div>
            <div class="rj-col-1">
              <el-form-item prop="additionalTerms" label="备注说明:">
                <el-input v-model.trim="info.rremarks" type="textarea" :rows="3" disabled placeholder="请输入备注说明" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // info: {},
      loading: false,
      form: {},
      rules: {}
    };
  },
  props: {
    info: {
      type: Object,
      default: () => { return {}; }
    }
  },
  mounted () {
  }
};
</script>

<style lang="scss" scoped>
.exchangeBaseInfo {
 .rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
}
}

</style>
